import type { CreatePageViewEventData } from '../types/index.js';

export const createPageViewEventData: CreatePageViewEventData = (data) => ({
  object: {
    url: window.location.href,
    ...data?.object,
  },
});
